import { render, staticRenderFns } from "./LicenseInformationModuleField.vue?vue&type=template&id=16da38fc&scoped=true"
import script from "./LicenseInformationModuleField.vue?vue&type=script&lang=ts"
export * from "./LicenseInformationModuleField.vue?vue&type=script&lang=ts"
import style0 from "./LicenseInformationModuleField.vue?vue&type=style&index=0&id=16da38fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da38fc",
  null
  
)

export default component.exports